
<script>
import AviaticketForm from './views/Form.vue'
import Flights from './views/Flights.vue'
import arrowIcon from '@/assets/images/icons/arrow-down.svg?inline'
import editIcon from '@/assets/images/icons/pencil.svg?inline'
import addIcon from '@/assets/images/icons/plus.svg?inline'
import removeIcon from '@/assets/images/icons/cancel.svg?inline'

export default {
  name: 'cart-flights',
  components: {
    AviaticketForm,
    Flights,
    arrowIcon,
    editIcon,
    addIcon,
    removeIcon,
  },
  data: () => ({
    active: false,
    formIsShown: true,
    resultIsShown: false
  }),
  computed: {
    flights() {
      return this.$store.getters['cart/getFlights']
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
    isCollectionLoading() {
      return this.$store.getters['cart/getFlight']
    },
    pagination() {
      return this.$store.getters['cart/getFlightPagination']
    }
  },
  methods: {
    addFlight() {
      this.active = true
      this.$store.commit('cart/setFlightInitial')
    },
    showForm() {
      this.formIsShown = true
      this.resultIsShown = false
    },
    removedForm() {
      this.active = false
      this.showForm()
      this.$store.commit('cart/clearFlightsState')
    },
    toggleTourFlights() {
      this.active = !this.active
    }
  }
}
</script>

<template>
  <div class="cart__services--item">
    <div
      v-if="!active && !mainServiceIsTours"
      class="cart__item-header cart__item-header--empty"
    >
      <h3>Авиаперелеты</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="addFlight"
        >
          <addIcon
            fill="#ffffff"
          />
          <span>добавить</span>
        </div>
      </div>
    </div>
    <div
      v-if="active && !mainServiceIsTours"
      class="cart__item-header"
    >
      <h3>Авиаперелеты</h3>
      <div class="cart__item-header--row-btn">
        <div
          v-if="resultIsShown"
          class="cart__item-header--btn"
          @click="showForm"
        >
          <editIcon
            fill="#ffffff"
          />
          <span>изменить</span>
        </div>
        <div
          class="cart__item-header--btn"
          @click="removedForm"
        >
          <removeIcon
            fill="#ffffff"
          />
          <span>удалить</span>
        </div>
      </div>
    </div>
    <div
      v-if="mainServiceIsTours"
      class="cart__item-header"
      :class="{ 'cart__item-header--empty-tour': !active }"
    >
      <h3>Авиаперелеты</h3>
      <div class="cart__item-header--row-btn">
        <div
          class="cart__item-header--btn"
          @click="toggleTourFlights"
        >
          <arrowIcon
            fill="#ffffff"
            class="cart__item-header--arrow-icon"
            :class="{ 'cart__item-header--arrow-icon-rotate': active }"
          />
        </div>
      </div>
    </div>
    <div
      v-if="active"
    >
      <div
        v-for="(flight, flightIndex) in flights"
        :key="flightIndex"
        class="cart__main"
        :class="{ 'cart__main--tour': mainServiceIsTours }"
      >
        <b-loading
          v-if="flight.isLoading"
          :is-full-page="false"
          :active="flight.isLoading"
        />
        <div
          v-if="!flight.isLoading"
          class="cart__item-content"
        >
          <aviaticket-form
            v-if="!flight.aviatickets.hasError && !mainServiceIsTours"
            :form-is-shown="formIsShown"
            :result-is-shown="resultIsShown"
            :flight-index="flightIndex"
          />
          <div
            v-if="flight.aviatickets.hasError"
          >
            <h2
              v-for="(error, index) in flight.aviatickets.errors"
              :key="index"
              class="cart__error"
            >
              {{ error }}
            </h2>
            <div class="cart__error-control">
              <a
                href="javascript:;"
                class="rex-btn"
                @click="showForm"
              >
                <span>Изменить</span>
              </a>
            </div>
          </div>
          <flights
            v-if="!flight.aviatickets.hasError"
            :result-is-shown="resultIsShown"
            :flight-index="flightIndex"
          />
        </div>
      </div>
    </div>
  </div>
</template>
